import appointmentsConfig from "./appointments";
import timetableConfig from "./timetable";
import messagesConfig from "./messages";

const getConfig = (view, userType) =>
  ({
    messages: messagesConfig(userType),
    appointments: appointmentsConfig(userType),
    timetable: timetableConfig
  }[view]);

export default getConfig;
